import React from 'react'
import { SubscriptionPlanV1 } from 'apis/response_types'
import { perMonth } from '../../components/door/index'
import { limitedPlanPriceSupplement } from "utils/subscriptionPlan";
export default function PlanPrice(props: {
  plan: SubscriptionPlanV1
}) {
  const { plan } = props
  return (
    (() => {
      if (
        plan.joinable_starts_at && 
        plan.joinable_months && 
        plan.available_days_after_joinable
      ) {
        return (
          <>
            <span className="plan-list-price-number">{plan.subscription_cost.toLocaleString()}</span>
            <span className="plan-list-bold">円</span>
            <span className='plan-list-bold'>{limitedPlanPriceSupplement(plan.subscription_cost, plan.joinable_months)}</span>（税込）
          </>
        )
      } else {
        if (plan.recurring) {
          return (
            <>
              <span className="plan-list-price-number">{plan.subscription_cost.toLocaleString()}</span>
              <span className="plan-list-bold">円</span>
              <span className='plan-list-bold'>{`/${perMonth(plan.payment_interval_months)}${plan.payment_interval_months === 1 ? '' : 'ごと'}`}</span>（税込）
            </>
          )
        } else {
          return (
            <>
              <span className="plan-list-bold">{`${perMonth(plan.payment_interval_months)}限定`}</span>
              <span className="plan-list-price-number">{plan.subscription_cost.toLocaleString()}</span>
              <span className="plan-list-bold">円</span>（税込）
            </>
          )
        }
      }
    })()
  )
}
